import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import InfoOverview from 'Routes/Parameters/components/InfoOverview';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import { addAdditionalBreadcrumbParams } from 'Store';
import {
    genParameterInfoOverviewBottom,
    genParameterInfoOverviewTop
} from 'Components/CreateExpressionForm/CreateExpressionForm';
import { addParameterValidationSchema } from 'Components/CreateExpressionForm/createExpressionSchema';
import ScriptOverview from 'Components/ScriptOverview';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import Layout from 'Components/Layout';
import Header from './Header';

const ViewExpression = () => {
    const parametersAPI = useGetParameters({});
    const { parameterId } = useParams<{ parameterId: string }>();
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (parametersAPI?.data && parameterId) {
            dispatch(
                addAdditionalBreadcrumbParams({
                    pathname: location.pathname,
                    params: {
                        parameterName: parametersAPI.data.idHashmap[Number(parameterId)].message
                    }
                })
            );
        }
    }, [location, parametersAPI, dispatch, parameterId]);

    if (parametersAPI.isLoading || parametersAPI.isFetching) return <RouteLoading />;
    if (parametersAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error]);
        return errorCmp;
    }

    const currentParameter = parametersAPI?.data?.idHashmap[Number(parameterId)];
    const initialValues: ParameterExpressionFormSchema = {
        displayName: currentParameter?.message ?? '',
        systemName: currentParameter?.fieldName ?? '',
        description: currentParameter?.description ?? '',
        expression: {
            expText: currentParameter?.expressionStatement ?? '',
            inputs: {},
            functionCalls: []
        },
        isScriptValidated: true,
        tppType: currentParameter?.tppType,
        status: currentParameter?.status
    };

    return (
        <Layout>
            <Formik
                initialValues={initialValues}
                validationSchema={addParameterValidationSchema(t)}
                onSubmit={() => {}}
            >
                {(formikProps) => {
                    const { handleChange, handleBlur, values } = formikProps;
                    const paramInfoOverviewTopData = genParameterInfoOverviewTop(
                        t,
                        true,
                        values,
                        handleChange,
                        handleBlur
                    );
                    const paramInfoOverviewBottomData = genParameterInfoOverviewBottom(
                        t,
                        true,
                        handleChange,
                        handleBlur
                    );

                    return (
                        <>
                            <Header />
                            <InfoOverview
                                dataTestId='parameterInformation'
                                leftTitle={t('Parameter Information')}
                                topData={paramInfoOverviewTopData}
                                bottomData={paramInfoOverviewBottomData}
                            />

                            <ScriptOverview
                                scriptType='parameter'
                                inputFields={[]}
                                parameterData={parametersAPI.data}
                                leftTitle={t('Parameter Statement')}
                                readOnly
                            />
                        </>
                    );
                }}
            </Formik>
        </Layout>
    );
};

export default ViewExpression;
